import { faLaptop, faMobileScreen, faTabletScreen } from '@inflearn/pro-solid-svg-icons';

export function mapIcon(kind: string) {
  if (kind === 'mobile') {
    return faMobileScreen;
  }
  if (kind === 'tablet') {
    return faTabletScreen;
  }
  return faLaptop;
}
